export enum EnumOpenMiniProgramType {
  /** uc */
  Uc = 'uc',
  /** 展览 */
  Show = 'show',
  /** 文房 */
  Wenfang = 'wenfang',
  /** 日课 */
  DayCourse = 'daycourse'
}
